import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { colourPrimary, colorLink, colorLinkHover } from 'Styles/colors.css';

const LinkButton = styled.button`
  border: 0;
  background-color: transparent;
  color: ${colorLink};
  text-decoration: none;
  padding: 6px;

  &:hover, &:focus {
    border: 0;
    background-color: transparent;
    color: ${colorLinkHover};
    text-decoration: underline;
  }
`;

const WveLinkButton = ({ handleClick, handleMouseDown, children, classes, className, title }) =>
  <LinkButton
    type="button"
    className={`btn ${classes} ${className}`}
    onClick={handleClick}
    onMouseDown={handleMouseDown}
    data-original-title={title}
  >
    {children}
  </LinkButton>;

WveLinkButton.defaultProps = {
  classes: '',
  children: null,
  handleClick: () => {},
  handleMouseDown: () => {},
  className: '',
  title: '',
};

WveLinkButton.propTypes = {
  handleClick: PropTypes.func,
  handleMouseDown: PropTypes.func,
  children: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.array,
    PropTypes.string,
  ]),
  classes: PropTypes.string,
  className: PropTypes.string,
  title: PropTypes.string,
};

export default WveLinkButton;



// WEBPACK FOOTER //
// ./app/javascript/packs/Shared/components/WveInputs/WveLinkButton/WveLinkButton.jsx